module.exports = __webpack_public_path__ + "media/images/icons/uk-professor-3abd6c597b903331676f143277548943.svg";